import { render, staticRenderFns } from "./workHistory.vue?vue&type=template&id=21e8e645&"
import script from "./workHistory.vue?vue&type=script&lang=js&"
export * from "./workHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports